module.exports = __webpack_public_path__ + "static/media/oax.cebb56b0.svg";